import React from "react";

interface ColorschemeProps {
  title: string;
  color: string;
  rgb: string;
  textColor?: string;
}

interface PortfolioColorschemeProps {
  ColorschemeData: ColorschemeProps[];
  primaryColor?: string;
}

interface IconProps {
  color: string;
}

const ColorSchemeIcon: React.FC<IconProps> = ({ color }) => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 46 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 23.6921V46.6921L22.8738 46.591L45.697 46.4394L45.8485 39.7163L46 33.0438L39.2843 32.9427C35.5982 32.8921 32.1647 32.8416 31.7102 32.8921C31.2053 32.8921 30.8013 32.7405 30.8013 32.5888C30.8013 32.4372 33.9824 30.4658 37.8705 28.2921C41.7585 26.068 44.9396 24.046 44.9396 23.7932C44.9396 23.1866 40.1427 14.7954 38.9308 13.2789L38.022 12.1669L34.5379 14.2394C32.6191 15.3515 31.0033 16.2108 30.9023 16.1097C30.8518 16.0592 31.8112 14.2394 33.0735 12.0658C34.3359 9.94269 35.3458 7.81961 35.2448 7.36467C35.0428 6.35368 24.944 0.489941 24.0351 0.843788C23.6817 0.995434 21.258 4.83719 18.6323 9.38664L13.8858 17.6262L13.7344 9.1339L13.6334 0.692139H6.81669H0V23.6921ZM11.1087 23.4394V44.1647H6.56422H2.01976V23.4394V2.71412H6.56422H11.1087V23.4394ZM32.1647 9.0328C31.8112 9.63939 27.5697 17.0196 22.7223 25.4108L13.8858 40.7273L13.7344 31.7801L13.6334 22.8328L19.2382 13.0768L24.843 3.32071L28.7816 5.64598C32.5181 7.81961 32.7201 8.02181 32.1647 9.0328ZM39.8397 19.1932C41.0516 21.3163 41.809 23.1866 41.607 23.3888C41.0011 23.8943 19.8441 36.0768 19.5412 36.0768C19.3897 36.0768 21.258 32.5888 23.7322 28.3427L28.1756 20.6592L32.6191 18.0306C35.0933 16.5647 37.2141 15.3515 37.416 15.3515C37.5675 15.3515 38.6279 17.0702 39.8397 19.1932ZM43.4248 39.6152V44.1647H28.9835H14.5928L15.5016 42.5976C16.663 40.6262 16.966 40.3735 21.9144 37.4921L26.0044 35.1163H34.7398L43.4248 35.0658V39.6152Z"
      fill={color}
    />
  </svg>
);

const PortfolioColorscheme: React.FC<PortfolioColorschemeProps> = ({
  ColorschemeData,
  primaryColor = "#2C2D2C",
}) => {
  return (
    <div id="colorscheme" className="py-6 md:py-12 w-ull xl:w-[95%]">
      <div className="flex gap-4 border-b border-gray-400 items-center py-2 pl-2  md:pl-8">
        <ColorSchemeIcon color={primaryColor} />
        <h3 className="text-[2rem] md:text-[3rem]">COLORSCHEME</h3>
      </div>

      <div className="flex flex-col items-center md:flex-row md:px-12 py-8 relative">
        {ColorschemeData.map((color, index) => {
          const zIndex = ColorschemeData.length - index;

          return (
            <div
              key={index}
              className="h-[350px] w-[90%] md:w-[450px] shadow-lg transition-all duration-500 transform hover:scale-x-110"
              style={{
                backgroundColor: color.color,
                transformOrigin: "center",
                zIndex: zIndex,
              }}
            >
              <div className="p-4 flex flex-col justify-between h-full text-right text-white">
                <p className={`text-[${color.textColor}] text-2xl`}>
                  {color.title}
                </p>
                <p className={`text-[${color.textColor}]`}>{color.rgb}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};


export default PortfolioColorscheme;
